const baseMutations = {
  setBaseList(store, baseList) {
    const allBasesOption = baseList.length > 1 ? [{ id: 0, name: '全拠点' }] : [];

    const baseItems = baseList.map((base) => ({
      id: base.id,
      name: base.name,
    }));

    const bases = [...allBasesOption, ...baseItems];
    store.commit('setBaseList', bases);
    baseMutations.setCurrentBases(store, bases);
  },
  setCurrentBases(store, bases) {
    const currentBases = bases.filter((base) => base.id !== 0);
    store.commit('setCurrentBases', currentBases);
  },
};

export default baseMutations;
